/* Grihvas: header word on scroll (mobile), variant-wise gallery, USP read-more, recommendation tabs */
(function () {
  function define(n, c) { if (!customElements.get(n)) customElements.define(n, c); }

  /* Mobile header: icon only at top, icon + "Grihvas" once the page is scrolled */
  var root = document.documentElement;
  function onScroll() { root.classList.toggle('gv-scrolled', (window.scrollY || root.scrollTop || 0) > 40); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Gallery: show only the photos of the chosen pack.
     A photo belongs to a pack when its alt text is exactly the pack name (or it is that pack's variant image).
     Packs without their own photos show all photos. */
  function filterGallery(vid) {
    var g = document.querySelector('gv-gallery');
    if (!g || !vid) return;
    vid = String(vid);
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gv-thumb]'));
    var own = thumbs.filter(function (t) { return t.dataset.gvGroup === vid; });
    thumbs.forEach(function (t) { t.hidden = own.length > 0 && t.dataset.gvGroup !== vid; });
    var wrap = g.querySelector('.gv-gallery__thumbs');
    if (wrap) { wrap.scrollLeft = 0; wrap.hidden = thumbs.filter(function (t) { return !t.hidden; }).length < 2; }
    if (own.length && typeof g.show === 'function') g.show(own[0].dataset.gvThumb);
    else if (own.length) {
      g.querySelectorAll('[data-gv-media]').forEach(function (im) { im.classList.toggle('is-active', im.dataset.gvMedia === own[0].dataset.gvThumb); });
    }
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('gv-product input[name="id"][type="radio"]')) filterGallery(t.value);
  });
  function initGallery() {
    var g = document.querySelector('gv-gallery[data-gv-variant]');
    if (g) filterGallery(g.dataset.gvVariant);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { customElements.whenDefined('gv-gallery').then(initGallery); });
  else customElements.whenDefined('gv-gallery').then(initGallery);

  /* Product USP: clamp long descriptions with Read more */
  class GvUsp extends HTMLElement {
    connectedCallback() {
      var b = this.querySelector('[data-gv-more]'), c = this.querySelector('.gv-usp__body');
      if (!b || !c) return;
      var self = this;
      requestAnimationFrame(function () { if (c.scrollHeight <= c.clientHeight + 4) { b.hidden = true; self.classList.add('is-open'); } });
      b.addEventListener('click', function () { var o = self.classList.toggle('is-open'); b.textContent = o ? 'Show less' : 'Read more'; });
    }
  }
  define('gv-usp', GvUsp);

  /* Tabs for "You may also like" */
  class GvTabs extends HTMLElement {
    connectedCallback() {
      var tabs = Array.prototype.slice.call(this.querySelectorAll('[data-gv-tab]'));
      var panels = Array.prototype.slice.call(this.querySelectorAll('[data-gv-panel]'));
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panels.forEach(function (p) { p.hidden = p.dataset.gvPanel !== t.dataset.gvTab; if (!p.hidden) p.scrollLeft = 0; });
        });
      });
    }
  }
  define('gv-tabs', GvTabs);
})();